import React from "react";
import "./Button.css";

const Button = ({
  type = "primary",
  size = "md",
  text,
  icon,
  onClick,
  className = "",
  disabled = false,
  fullWidth = false,
}) => {
  const buttonClasses = `btn btn-${type} btn-${size} ${
    fullWidth ? "btn-full" : ""
  } ${className}`;

  return (
    <button className={buttonClasses} onClick={onClick} disabled={disabled}>
      {icon && <i className={icon}></i>}
      {text}
    </button>
  );
};

export default Button;
